import React from 'react';
 
const ProjectProvider = React.createContext(null);
 
export default ProjectProvider;